import { useEffect } from "react";
import AlertMessage from "@/components/alert-message/AlertMessage";

interface TopAlertMessageAlertMessageProps {
  closeMessage: () => void;
  titleLabel: string;
  textLabel: string;
  contentType: "success" | "error" | "warning" | "info";
  links?: string | string[] | undefined;
  width?: number | string;
  formatType?: "feedback" | "persistent";
  formattedText?: boolean;
  textData?: string[];
  zIdex?: number;
  secondsToClose?: number | false;
}

const TopAlertMessageAlertMessage = ({
  closeMessage,
  titleLabel,
  textLabel,
  contentType,
  links,
  width,
  formatType,
  formattedText,
  textData,
  zIdex = 1005,
  secondsToClose = 100,
}: TopAlertMessageAlertMessageProps) => {
  useEffect(() => {
    if (secondsToClose) {
      const timer: NodeJS.Timeout = setTimeout(() => {
        closeMessage();
      }, secondsToClose * 1000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, []);

  return (
    <div
      className={`w-full md:w-fit md:max-w-full fixed top-[30px] right-1/2 transform translate-x-1/2 z-[${zIdex}]`}
    >
      <AlertMessage
        titleLabel={titleLabel}
        textLabel={textLabel}
        contentType={contentType}
        formatType={formatType}
        onClose={closeMessage}
        links={links}
        width={width}
        formattedText={formattedText}
        textData={textData}
      />
    </div>
  );
};

export default TopAlertMessageAlertMessage;
